import { LAYOUT } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
  {
    path: '/home',
    component: LAYOUT,
    redirect: '/home/index',
    meta: { title: '首页' },
    children: [
      {
        path: 'index',
        component: () => import('@/views/home/index.vue'),
        meta: { title: '首页', hide: true },
      },
    ],
  },
]
